"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es6.regexp.split");
var _storage = require("@/api/storage");
var _multiLanguageDisplay = require("@/utils/multiLanguageDisplay");
var _auth = require("@/utils/auth");
var _elementUi = require("element-ui");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: 'EditorVideo',
  props: {
    color: {
      type: String,
      default: '#1890ff'
    }
  },
  computed: {
    headers: function headers() {
      return {
        'Mu-Token': (0, _auth.getToken)()
      };
    }
  },
  data: function data() {
    return {
      percentage: 0,
      checkFileType: _multiLanguageDisplay.checkFileType,
      uploadPath: _storage.uploadPath,
      show: false,
      file: '',
      dialogVisible: false
    };
  },
  methods: {
    progress: function progress(file, file2, file3) {
      this.show = true;
      this.percentage = Math.min(parseInt(file.percent), 99);
    },
    // 图片拖拽排序、图片上传前格式、大小限制
    beforeAvatarUpload: function beforeAvatarUpload(file) {
      // const isLt10M = file.size / 1024 / 1024 < 1000
      // if (!isLt10M) {
      //   this.$message.error('视频大小不超过10M')
      //   return false
      // }
      var vides = ['mp4', 'avi', 'mov', 'rmvb', 'wmv'];
      var isVideo = vides.some(function (item) {
        return item.indexOf(file.type.split('/')[1]) >= 0;
      });
      if (!isVideo) {
        this.$message.error('请上传视频');
        return false;
      }
      return true;
    },
    handleAvatarSuccess: function handleAvatarSuccess(res) {
      var _this = this;
      this.percentage = 100;
      setTimeout(function () {
        _this.percentage = 0;
        _this.show = false;
      }, 3000);
      this.file = res.data.url;
    },
    handleAvatarError: function handleAvatarError(err) {
      this.percentage = 0;
      this.show = false;
      this.$message.error('视频上传失败');
    },
    // 确认
    handleSubmit: function handleSubmit() {
      this.$emit('success', this.file);
      this.file = '';
      this.dialogVisible = false;
    },
    close: function close() {
      // 中止上传
      if (this.$refs.upload) {
        this.$refs.upload.abort();
      }
      // 重置状态
      this.file = '';
      this.show = false;
      this.percentage = 0;
      this.dialogVisible = false;
    }
  }
};